import React from 'react';

import { Alert } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
/**
 * Banner to display info for promo code to be applied.
 *
 * Just cuts down on a bit of code repetition as this is used across multiple pages in the funnel.
 *
 * Extend as needed to override CSS etc; for now this works as is!
 */
const PromoCodeBanner: React.FC<{
  discountCode?: string;
  discountCodePublicDescription?: string;
  referralCode?: string;
  authenticated: boolean;
}> = ({
  discountCode,
  discountCodePublicDescription,
  referralCode,
  authenticated,
}) => {
  // If neither of these inputs exist, we have nothing to show
  if (!discountCode && !referralCode) {
    return null;
  }

  let copy;
  if (referralCode) {
    // For referral codes, use the default copy
    copy =
      `The code ${referralCode} will be applied at checkout` +
      (!authenticated ? " once you've logged in or signed up" : '');
  } else if (discountCode && !discountCodePublicDescription) {
    // For discount codes without a description, use the default copy
    copy =
      `The code ${discountCode} will be applied at checkout` +
      (!authenticated ? " once you've logged in or signed up" : '');
  } else if (discountCode && discountCodePublicDescription) {
    // For discount codes who've provided a public description, use that custom copy
    copy = discountCodePublicDescription;
  }

  return (
    <Alert
      severity="success"
      icon={<TaskAltIcon />}
      sx={{
        mb: 3,
        backgroundColor: '#EDFAF7',
        color: '#054D27',
        border: '1px solid',
        borderColor: '#B9EBDF',
        borderRadius: '8px',
        fontSize: '0.95rem',
        fontWeight: 500,
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        },
      }}
    >
      {copy}
    </Alert>
  );
};

export default PromoCodeBanner;
